import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import consultationImage from '@/assets/images/trial_consultation.png';
import { MdCalendarToday, MdCheck, MdClose } from 'react-icons/md';
import { TRIAL_BOOKING_URL } from '@/features/agent/trialConstants';

/** 機能紹介リスト */
const FEATURES = [
  '求職者向けの応募フォームを作成',
  '求職者マイページをワンタッチで作成',
  '求職者をボードビューで直感的に管理',
  '応募後の進捗状況が一目で分かる',
];

/** 相談モーダル */
export default function ConsultationModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="w-[1000px] max-w-[90vw] overflow-hidden rounded-xl p-0">
        <VisuallyHidden.Root>
          <DialogTitle>無料オンライン相談</DialogTitle>
        </VisuallyHidden.Root>

        <div className="flex h-[600px]">
          {/* 左側：機能紹介 */}
          <div
            className="relative flex w-[518px] shrink-0 flex-col items-center justify-center overflow-hidden px-9 text-white"
            style={{
              background: 'linear-gradient(229deg, #ed72f8 0%, #005fff 88%)',
            }}
          >
            <img
              src="/agent/trial/decorate.svg"
              alt=""
              className="pointer-events-none absolute top-0 right-0"
              aria-hidden="true"
            />

            {/* タイトル */}
            <div className="mb-[65.22px] text-center">
              <p className="text-[22.24px] leading-[140%] font-bold">
                <img
                  src="/agent/trial/agenthub-logo.svg"
                  alt="AgentHub"
                  height={30.666}
                  width={238.613}
                />
                の機能を
                <br />
                全て試してみませんか？
              </p>
            </div>

            {/* サブタイトル */}
            <p className="mb-[27px] text-heading-md">\ 転職支援業務をAll in Oneサポート /</p>

            {/* 機能リスト */}
            <div className="mb-[27px] flex flex-col gap-xs">
              {FEATURES.map((feature) => (
                <div key={feature} className="flex items-center gap-xs">
                  <MdCheck size={24} />
                  <span className="text-xl leading-[170%]">{feature}</span>
                </div>
              ))}
            </div>

            <div className="h-[28px] w-full"></div>
          </div>

          {/* 右側：相談案内 */}
          <div className="relative flex w-full items-center justify-center">
            {/* 背景装飾 - 上部 */}
            <img
              src="/agent/trial/decorate-top.svg"
              alt=""
              className="pointer-events-none absolute top-0 right-0"
              aria-hidden="true"
            />

            {/* 背景装飾 - 下部 */}
            <img
              src="/agent/trial/decorate-bottom.svg"
              alt=""
              className="pointer-events-none absolute bottom-0 left-0"
              aria-hidden="true"
            />

            {/* 閉じるボタン */}
            <button
              type="button"
              onClick={onClose}
              className="absolute top-3 right-3 z-10 flex size-xxl items-center justify-center rounded-full bg-white hover:opacity-50"
            >
              <MdClose size={24} className="text-placeholder" />
            </button>
            <div className="relative flex flex-1 flex-col items-center p-lg">
              {/* 見出し */}
              <p
                className="text-heading-lg"
                style={{
                  background: 'linear-gradient(186deg, #ed72f8 0%, #005fff 88%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                \ 無料オンライン相談実施中 /
              </p>

              {/* イラスト */}
              <img
                src={consultationImage}
                alt="オンライン相談"
                className="my-xxl object-contain"
                width={217}
                height={199}
              />

              {/* 説明文 */}
              <p className="mb-lg text-left text-body-xs">
                トライアル版をご利用いただきありがとうございます。
                <br />
                ご導入後の運用イメージや費用対効果について、詳しく
                <br />
                ご説明いたします。まずは30分程度のオンライン相談で、
                <br />
                貴社専用の活用イメージをご確認ください。
              </p>

              {/* CTAボタン */}
              <a
                href={TRIAL_BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-[55px] w-full max-w-[352px] items-center justify-center gap-xxs rounded-full bg-primary text-button-lg text-white hover:text-white hover:opacity-50"
              >
                <MdCalendarToday size={20} />
                まずは空き状況をチェック
              </a>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
